import type React from 'react';

/**
 * Prevents a form from submitting when Enter is pressed in a text/number input.
 * Use as onKeyDown handler on inputs inside a <form> that should not submit on Enter.
 * Shift+Enter is allowed through (for future textarea compatibility).
 */
export function preventEnterSubmit(e: React.KeyboardEvent): void {
  if (e.key === 'Enter' && !e.shiftKey) {
    e.preventDefault();
  }
}
